import { QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';
import { BusinessTags, ENDPOINTS } from '../constants';
export const DomainsServerlessConfig = {
  name: 'DomainsServerlessApiConfig',
  baseUrl: '/_serverless/premium-domains-serverless',
  defaultQueryConfigType: QueryConfigTypes.DYNAMIC_DATA
};
export const DomainsServicesApiConfig = {
  name: 'DomainsServicesApiConfig',
  baseUrl: '/_serverless/domains-serverless-services',
  defaultQueryConfigType: QueryConfigTypes.DYNAMIC_DATA
};

// TODO: (Omer) we're using the old ENDPOINTS just to be sure the serverless and this config uses the same paths
// the serverless should import the configuration and set the paths according to it instead of using ENDPOINTS,
// after that we need to delete ENDPOINTS and use the configuration 'path' fields as single source for urls

const memoizedExperiments = {
  experiments: {}
};
export const DomainsServerlessApiConfig = {
  domainsAccount: {
    name: 'domainsAccount',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.accountParams,
    // '/domains-account',
    queryConfigType: QueryConfigTypes.MODERATE_DATA,
    tags: [BusinessTags.domainRegistration, BusinessTags.domainAssignment, BusinessTags.listDomains],
    requestTransform: req => ({
      ...req,
      limit: req.limit ?? 50
    })
  },
  domainsAccountPermissions: {
    name: 'domainsAccountPermissions',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainPermissions,
    queryConfigType: QueryConfigTypes.MODERATE_DATA,
    tags: [BusinessTags.domainRegistration]
  },
  domainsLoggerBase: {
    name: 'domainsLoggerBase',
    service: DomainsServerlessConfig,
    path: '/domains-logger',
    httpMethod: 'post'
  },
  ipsTags: {
    name: 'ipsTags',
    httpMethod: 'get',
    service: DomainsServerlessConfig,
    path: '/domain-ips-tags',
    queryConfigType: QueryConfigTypes.FIXED_DATA
  },
  domainTlds: {
    name: 'domainTlds',
    httpMethod: 'get',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainTlds,
    // '/domain-tlds/list-tlds',
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  experiments: {
    name: 'experiments',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.experiments,
    // '/experiments',
    httpMethod: 'get',
    queryConfigType: QueryConfigTypes.STATIC_DATA,
    keyTransform: req => {
      var _req$experiments;
      // create memoized key to only fetch when new keys are requested
      memoizedExperiments.experiments = {
        ...((_req$experiments = req.experiments) == null ? void 0 : _req$experiments.reduce((acc, spec) => ({
          ...acc,
          [spec]: undefined
        }), {})),
        ...memoizedExperiments.experiments
      };
      memoizedExperiments.experiments = Object.fromEntries(Object.entries(memoizedExperiments.experiments).sort());
      return Object.keys(memoizedExperiments.experiments);
    },
    responseTransform: rawResponse => {
      // add new requested specs to the memoized values
      memoizedExperiments.experiments = {
        ...memoizedExperiments.experiments,
        ...rawResponse.experiments
      };
      return memoizedExperiments;
    }
  },
  dayfullData: {
    name: 'dayfullData',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.dayfull.projectsData,
    // '/dayfull/projects-data',
    httpMethod: 'get',
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  canChangeDomainOwner: {
    name: 'canChangeDomainOwner',
    service: DomainsServicesApiConfig,
    path: ENDPOINTS.canChangeDomainOwner,
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  getWhoisAvailabilityBase: {
    name: 'getWhoisAvailabilityBase',
    service: DomainsServicesApiConfig,
    path: '/whois/availability',
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  domainAvailability: {
    name: 'domainAvailability',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainAvailability,
    // '/domain-search/domain-availability',
    tags: [BusinessTags.domainRegistration, BusinessTags.domainAssignment],
    keyTransform: req => {
      var _req$domainData, _req$parsedDomain;
      return {
        domainName: ((_req$domainData = req.domainData) == null || (_req$domainData = _req$domainData.parsedDomain) == null ? void 0 : _req$domainData.main) ?? ((_req$parsedDomain = req.parsedDomain) == null ? void 0 : _req$parsedDomain.main) ?? req.domainName,
        disableSuggestions: req.disableSuggestions,
        msid: req.msid
      };
    }
  },
  domainSuggestions: {
    name: 'domainSuggestions',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainSearchSuggestions,
    // '/domain-search/suggestions',
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  domainData: {
    name: 'domainData',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainSearchDomainData,
    // '/domain-search/domain-data',
    keyTransform: req => {
      var _req$parsedDomain2;
      return ((_req$parsedDomain2 = req.parsedDomain) == null ? void 0 : _req$parsedDomain2.main) ?? req.domainName;
    }
  },
  domainConnection: {
    name: 'domainConnection',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainConnection.statuses,
    // '/domain-connection/statuses',
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  domainInstances: {
    name: 'domainInstances',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainConnection.instances // '/domain-connection/instances',
  },
  getDomainSeenStatuses: {
    name: 'getDomainSeenStatuses',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainConnection.seenStatuses // '/domain-connection/seen-statuses',
  },
  setDomainSeenStatuses: {
    name: 'setDomainSeenStatuses',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainConnection.seenStatuses // '/domain-connection/seen-statuses',
  },
  getHiddenTransferIdRequests: {
    name: 'getHiddenTransferIdRequests',
    service: DomainsServerlessConfig,
    httpMethod: 'get',
    path: ENDPOINTS.domainConnection.hiddenTransfers // '/domain-connection/hidden-transfers',
  },
  setHiddenTransferIdRequests: {
    name: 'setHiddenTransferIdRequests',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.domainConnection.hiddenTransfers // '/domain-connection/hidden-transfers',
  },
  capabilities: {
    name: 'capabilities',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.capabilities,
    // '/capabilities',
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  resellerData: {
    name: 'resellerData',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.resellers,
    // '/resellers/get-domain-data',
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  resellerBrandingInfo: {
    name: 'resellerBrandingInfo',
    service: DomainsServerlessConfig,
    path: ENDPOINTS.resellersBrandingInfo,
    // '/resellers/get-branding-info',
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  domainStartingFromPricing: {
    name: 'domainStartingFromPricing',
    service: DomainsServerlessConfig,
    httpMethod: 'get',
    path: ENDPOINTS.domainStartingFromPricing,
    // '/domain-pricing/starting-from',
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  chatGptCompletion: {
    name: 'chatGptCompletion',
    service: DomainsServicesApiConfig,
    path: '/chat-gpt/completion',
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
  },
  domainsGptSuggestions: {
    name: 'domainsGptSuggestions',
    service: DomainsServicesApiConfig,
    path: '/chat-gpt/domains-completion',
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
  },
  domainsGptSuggestionsV2: {
    name: 'domainsGptSuggestionsV2',
    service: DomainsServicesApiConfig,
    path: '/chat-gpt/domains-completion/v2',
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
  },
  brandProtection: {
    name: 'brandProtection',
    service: DomainsServicesApiConfig,
    path: '/brand-protection',
    queryConfigType: QueryConfigTypes.DYNAMIC_DATA
  },
  domainsMatchingLabel: {
    name: 'domainsMatchingLabel',
    service: DomainsServicesApiConfig,
    httpMethod: 'get',
    path: '/domains-matching-label',
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
  },
  tldWhiteList: {
    name: 'tldWhiteList',
    service: DomainsServicesApiConfig,
    path: '/tld-white-list',
    httpMethod: 'get',
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  singleDomainGptSuggestion: {
    name: 'singleDomainGptSuggestion',
    service: DomainsServicesApiConfig,
    path: '/chat-gpt/single-domain-completion',
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
  },
  domainSetupInfo: {
    name: 'domainSetupInfo',
    service: DomainsServicesApiConfig,
    path: '/domain-setup-info',
    httpMethod: 'get',
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  preCreateConnectedDomain: {
    name: 'preCreateConnectedDomain',
    service: DomainsServicesApiConfig,
    path: '/pre-create-connected-domain',
    httpMethod: 'post',
    queryConfigType: QueryConfigTypes.MUTATION_METHOD,
    isMutating: true
  },
  listAudit: {
    name: 'listAudit',
    service: DomainsServicesApiConfig,
    path: '/list-audit',
    httpMethod: 'POST',
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  bulkDomainsSuggestions: {
    name: 'bulkDomainsSuggestions',
    service: DomainsServicesApiConfig,
    path: '/domain-search/bulk-suggestions'
  },
  productsCatalogQuery: {
    name: 'productsCatalogQuery',
    service: DomainsServicesApiConfig,
    path: '/product-catalog/query-product',
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  isEligibleForFunnel: {
    name: 'isEligibleForFunnel',
    service: DomainsServicesApiConfig,
    path: '/express-checkout/is-eligible-to-funnel',
    queryConfigType: QueryConfigTypes.DYNAMIC_DATA
  },
  isEligibleForCart: {
    name: 'isEligibleForCart',
    service: DomainsServicesApiConfig,
    path: '/express-checkout/is-eligible',
    queryConfigType: QueryConfigTypes.DYNAMIC_DATA
  },
  domainTakenInAnotherAccountEntriEligibility: {
    name: 'domainTakenInAnotherAccountEntriEligibility',
    service: DomainsServicesApiConfig,
    path: '/entri/taken-in-another-account',
    httpMethod: 'POST',
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  entriConfig: {
    name: 'entriConfig',
    service: DomainsServicesApiConfig,
    path: '/entri/config',
    httpMethod: 'POST',
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  forceDomainCheck: {
    name: 'forceDomainCheck',
    service: DomainsServicesApiConfig,
    path: '/force-domain-check',
    httpMethod: 'POST',
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
  },
  domainProductIds: {
    name: 'domainProductIds',
    service: DomainsServicesApiConfig,
    path: '/domainProductIds',
    httpMethod: 'POST',
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  domainLastRenewalDate: {
    name: 'domainLastRenewalDate',
    service: DomainsServicesApiConfig,
    path: '/last-renewal',
    httpMethod: 'POST',
    queryConfigType: QueryConfigTypes.DYNAMIC_DATA
  },
  mailboxInfo: {
    name: 'mailboxInfo',
    service: DomainsServicesApiConfig,
    path: '/mailbox-info',
    httpMethod: 'get',
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  dnsPropagation: {
    name: 'dnsPropagation',
    service: DomainsServicesApiConfig,
    path: '/domain-propagation',
    httpMethod: 'get',
    queryConfigType: QueryConfigTypes.STATIC_DATA
  }
};
//# sourceMappingURL=DomainsServerlessApiConfig.js.map